/**
 * @module FinancialStoriesConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const FinancialStoriesConstants
 */
const FinancialStoriesConstants = keyMirror({
  FINANCIAL_STORIES_CONNECTION_REQUEST: null,
  FINANCIAL_STORIES_CONNECTION_SUCCESS: null,
  FINANCIAL_STORIES_CONNECTION_ERROR: null,
  SET_TILETYPE: null,
  MICRO_TRANSACTION_REQUEST: null,
  CASHPOINT_REQUEST: null,
  IN_OUT_REQUEST: null,
  MICRO_TRANSACTION_REQUEST_SUCCESS: null,
  CASHPOINT_REQUEST_SUCCESS: null,
  IN_OUT_REQUEST_SUCCESS: null,
  RESET_ERROR_FLAG: null,
});

export default FinancialStoriesConstants;
